/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AccionRouteImport } from './routes/accion'
import { Route as CambiarClaveRouteImport } from './routes/cambiar-clave'
import { Route as IngresarRouteImport } from './routes/ingresar'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppActividadRouteImport } from './routes/_app/actividad'
import { Route as AppRepuestosRouteImport } from './routes/_app/repuestos'
import { Route as AppTableroRouteImport } from './routes/_app/tablero'
import { Route as AppAdminAuditoriaRouteImport } from './routes/_app/admin/auditoria'
import { Route as AppAdminConfiguracionRouteImport } from './routes/_app/admin/configuracion'
import { Route as AppAdminEquiposRouteImport } from './routes/_app/admin/equipos'
import { Route as AppAdminUsuariosRouteImport } from './routes/_app/admin/usuarios'
import { Route as AppInspeccionesIndexRouteImport } from './routes/_app/inspecciones/index'
import { Route as AppInspeccionesInspeccionIdRouteImport } from './routes/_app/inspecciones/$inspeccionId'
import { Route as AppPlataformaContactosRouteImport } from './routes/_app/plataforma/contactos'
import { Route as AppPlataformaCorreosRouteImport } from './routes/_app/plataforma/correos'
import { Route as AppPlataformaCuponesRouteImport } from './routes/_app/plataforma/cupones'
import { Route as AppPlataformaMetricasRouteImport } from './routes/_app/plataforma/metricas'
import { Route as AppPlataformaTalleresRouteImport } from './routes/_app/plataforma/talleres'
import { Route as AppVehiculosPatenteRouteImport } from './routes/_app/vehiculos/$patente'
import { Route as AppPlataformaTalleresTallerIdComercialRouteImport } from './routes/_app/plataforma/talleres_.$tallerId.comercial'
import { Route as AppPlataformaTalleresTallerIdFotosRouteImport } from './routes/_app/plataforma/talleres_.$tallerId.fotos'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AccionRoute = AccionRouteImport.update({
  id: '/accion',
  path: '/accion',
  getParentRoute: () => rootRouteImport,
} as any)
const CambiarClaveRoute = CambiarClaveRouteImport.update({
  id: '/cambiar-clave',
  path: '/cambiar-clave',
  getParentRoute: () => rootRouteImport,
} as any)
const IngresarRoute = IngresarRouteImport.update({
  id: '/ingresar',
  path: '/ingresar',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppActividadRoute = AppActividadRouteImport.update({
  id: '/actividad',
  path: '/actividad',
  getParentRoute: () => AppRoute,
} as any)
const AppRepuestosRoute = AppRepuestosRouteImport.update({
  id: '/repuestos',
  path: '/repuestos',
  getParentRoute: () => AppRoute,
} as any)
const AppTableroRoute = AppTableroRouteImport.update({
  id: '/tablero',
  path: '/tablero',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminAuditoriaRoute = AppAdminAuditoriaRouteImport.update({
  id: '/admin/auditoria',
  path: '/admin/auditoria',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminConfiguracionRoute = AppAdminConfiguracionRouteImport.update({
  id: '/admin/configuracion',
  path: '/admin/configuracion',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminEquiposRoute = AppAdminEquiposRouteImport.update({
  id: '/admin/equipos',
  path: '/admin/equipos',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminUsuariosRoute = AppAdminUsuariosRouteImport.update({
  id: '/admin/usuarios',
  path: '/admin/usuarios',
  getParentRoute: () => AppRoute,
} as any)
const AppInspeccionesIndexRoute = AppInspeccionesIndexRouteImport.update({
  id: '/inspecciones/',
  path: '/inspecciones/',
  getParentRoute: () => AppRoute,
} as any)
const AppInspeccionesInspeccionIdRoute =
  AppInspeccionesInspeccionIdRouteImport.update({
    id: '/inspecciones/$inspeccionId',
    path: '/inspecciones/$inspeccionId',
    getParentRoute: () => AppRoute,
  } as any)
const AppPlataformaContactosRoute = AppPlataformaContactosRouteImport.update({
  id: '/plataforma/contactos',
  path: '/plataforma/contactos',
  getParentRoute: () => AppRoute,
} as any)
const AppPlataformaCorreosRoute = AppPlataformaCorreosRouteImport.update({
  id: '/plataforma/correos',
  path: '/plataforma/correos',
  getParentRoute: () => AppRoute,
} as any)
const AppPlataformaCuponesRoute = AppPlataformaCuponesRouteImport.update({
  id: '/plataforma/cupones',
  path: '/plataforma/cupones',
  getParentRoute: () => AppRoute,
} as any)
const AppPlataformaMetricasRoute = AppPlataformaMetricasRouteImport.update({
  id: '/plataforma/metricas',
  path: '/plataforma/metricas',
  getParentRoute: () => AppRoute,
} as any)
const AppPlataformaTalleresRoute = AppPlataformaTalleresRouteImport.update({
  id: '/plataforma/talleres',
  path: '/plataforma/talleres',
  getParentRoute: () => AppRoute,
} as any)
const AppVehiculosPatenteRoute = AppVehiculosPatenteRouteImport.update({
  id: '/vehiculos/$patente',
  path: '/vehiculos/$patente',
  getParentRoute: () => AppRoute,
} as any)
const AppPlataformaTalleresTallerIdComercialRoute =
  AppPlataformaTalleresTallerIdComercialRouteImport.update({
    id: '/plataforma/talleres_/$tallerId/comercial',
    path: '/plataforma/talleres/$tallerId/comercial',
    getParentRoute: () => AppRoute,
  } as any)
const AppPlataformaTalleresTallerIdFotosRoute =
  AppPlataformaTalleresTallerIdFotosRouteImport.update({
    id: '/plataforma/talleres_/$tallerId/fotos',
    path: '/plataforma/talleres/$tallerId/fotos',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/accion': typeof AccionRoute
  '/cambiar-clave': typeof CambiarClaveRoute
  '/ingresar': typeof IngresarRoute
  '/actividad': typeof AppActividadRoute
  '/repuestos': typeof AppRepuestosRoute
  '/tablero': typeof AppTableroRoute
  '/admin/auditoria': typeof AppAdminAuditoriaRoute
  '/admin/configuracion': typeof AppAdminConfiguracionRoute
  '/admin/equipos': typeof AppAdminEquiposRoute
  '/admin/usuarios': typeof AppAdminUsuariosRoute
  '/inspecciones/$inspeccionId': typeof AppInspeccionesInspeccionIdRoute
  '/plataforma/contactos': typeof AppPlataformaContactosRoute
  '/plataforma/correos': typeof AppPlataformaCorreosRoute
  '/plataforma/cupones': typeof AppPlataformaCuponesRoute
  '/plataforma/metricas': typeof AppPlataformaMetricasRoute
  '/plataforma/talleres': typeof AppPlataformaTalleresRoute
  '/vehiculos/$patente': typeof AppVehiculosPatenteRoute
  '/inspecciones/': typeof AppInspeccionesIndexRoute
  '/plataforma/talleres/$tallerId/comercial': typeof AppPlataformaTalleresTallerIdComercialRoute
  '/plataforma/talleres/$tallerId/fotos': typeof AppPlataformaTalleresTallerIdFotosRoute
}
export interface FileRoutesByTo {
  '/accion': typeof AccionRoute
  '/cambiar-clave': typeof CambiarClaveRoute
  '/ingresar': typeof IngresarRoute
  '/actividad': typeof AppActividadRoute
  '/repuestos': typeof AppRepuestosRoute
  '/tablero': typeof AppTableroRoute
  '/': typeof AppIndexRoute
  '/admin/auditoria': typeof AppAdminAuditoriaRoute
  '/admin/configuracion': typeof AppAdminConfiguracionRoute
  '/admin/equipos': typeof AppAdminEquiposRoute
  '/admin/usuarios': typeof AppAdminUsuariosRoute
  '/inspecciones/$inspeccionId': typeof AppInspeccionesInspeccionIdRoute
  '/plataforma/contactos': typeof AppPlataformaContactosRoute
  '/plataforma/correos': typeof AppPlataformaCorreosRoute
  '/plataforma/cupones': typeof AppPlataformaCuponesRoute
  '/plataforma/metricas': typeof AppPlataformaMetricasRoute
  '/plataforma/talleres': typeof AppPlataformaTalleresRoute
  '/vehiculos/$patente': typeof AppVehiculosPatenteRoute
  '/inspecciones': typeof AppInspeccionesIndexRoute
  '/plataforma/talleres/$tallerId/comercial': typeof AppPlataformaTalleresTallerIdComercialRoute
  '/plataforma/talleres/$tallerId/fotos': typeof AppPlataformaTalleresTallerIdFotosRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/accion': typeof AccionRoute
  '/cambiar-clave': typeof CambiarClaveRoute
  '/ingresar': typeof IngresarRoute
  '/_app/actividad': typeof AppActividadRoute
  '/_app/repuestos': typeof AppRepuestosRoute
  '/_app/tablero': typeof AppTableroRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/auditoria': typeof AppAdminAuditoriaRoute
  '/_app/admin/configuracion': typeof AppAdminConfiguracionRoute
  '/_app/admin/equipos': typeof AppAdminEquiposRoute
  '/_app/admin/usuarios': typeof AppAdminUsuariosRoute
  '/_app/inspecciones/$inspeccionId': typeof AppInspeccionesInspeccionIdRoute
  '/_app/plataforma/contactos': typeof AppPlataformaContactosRoute
  '/_app/plataforma/correos': typeof AppPlataformaCorreosRoute
  '/_app/plataforma/cupones': typeof AppPlataformaCuponesRoute
  '/_app/plataforma/metricas': typeof AppPlataformaMetricasRoute
  '/_app/plataforma/talleres': typeof AppPlataformaTalleresRoute
  '/_app/vehiculos/$patente': typeof AppVehiculosPatenteRoute
  '/_app/inspecciones/': typeof AppInspeccionesIndexRoute
  '/_app/plataforma/talleres_/$tallerId/comercial': typeof AppPlataformaTalleresTallerIdComercialRoute
  '/_app/plataforma/talleres_/$tallerId/fotos': typeof AppPlataformaTalleresTallerIdFotosRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accion'
    | '/cambiar-clave'
    | '/ingresar'
    | '/actividad'
    | '/repuestos'
    | '/tablero'
    | '/admin/auditoria'
    | '/admin/configuracion'
    | '/admin/equipos'
    | '/admin/usuarios'
    | '/inspecciones/$inspeccionId'
    | '/plataforma/contactos'
    | '/plataforma/correos'
    | '/plataforma/cupones'
    | '/plataforma/metricas'
    | '/plataforma/talleres'
    | '/vehiculos/$patente'
    | '/inspecciones/'
    | '/plataforma/talleres/$tallerId/comercial'
    | '/plataforma/talleres/$tallerId/fotos'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/accion'
    | '/cambiar-clave'
    | '/ingresar'
    | '/actividad'
    | '/repuestos'
    | '/tablero'
    | '/'
    | '/admin/auditoria'
    | '/admin/configuracion'
    | '/admin/equipos'
    | '/admin/usuarios'
    | '/inspecciones/$inspeccionId'
    | '/plataforma/contactos'
    | '/plataforma/correos'
    | '/plataforma/cupones'
    | '/plataforma/metricas'
    | '/plataforma/talleres'
    | '/vehiculos/$patente'
    | '/inspecciones'
    | '/plataforma/talleres/$tallerId/comercial'
    | '/plataforma/talleres/$tallerId/fotos'
  id:
    | '__root__'
    | '/_app'
    | '/accion'
    | '/cambiar-clave'
    | '/ingresar'
    | '/_app/actividad'
    | '/_app/repuestos'
    | '/_app/tablero'
    | '/_app/'
    | '/_app/admin/auditoria'
    | '/_app/admin/configuracion'
    | '/_app/admin/equipos'
    | '/_app/admin/usuarios'
    | '/_app/inspecciones/$inspeccionId'
    | '/_app/plataforma/contactos'
    | '/_app/plataforma/correos'
    | '/_app/plataforma/cupones'
    | '/_app/plataforma/metricas'
    | '/_app/plataforma/talleres'
    | '/_app/vehiculos/$patente'
    | '/_app/inspecciones/'
    | '/_app/plataforma/talleres_/$tallerId/comercial'
    | '/_app/plataforma/talleres_/$tallerId/fotos'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AccionRoute: typeof AccionRoute
  CambiarClaveRoute: typeof CambiarClaveRoute
  IngresarRoute: typeof IngresarRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accion': {
      id: '/accion'
      path: '/accion'
      fullPath: '/accion'
      preLoaderRoute: typeof AccionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cambiar-clave': {
      id: '/cambiar-clave'
      path: '/cambiar-clave'
      fullPath: '/cambiar-clave'
      preLoaderRoute: typeof CambiarClaveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ingresar': {
      id: '/ingresar'
      path: '/ingresar'
      fullPath: '/ingresar'
      preLoaderRoute: typeof IngresarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/actividad': {
      id: '/_app/actividad'
      path: '/actividad'
      fullPath: '/actividad'
      preLoaderRoute: typeof AppActividadRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/repuestos': {
      id: '/_app/repuestos'
      path: '/repuestos'
      fullPath: '/repuestos'
      preLoaderRoute: typeof AppRepuestosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tablero': {
      id: '/_app/tablero'
      path: '/tablero'
      fullPath: '/tablero'
      preLoaderRoute: typeof AppTableroRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/auditoria': {
      id: '/_app/admin/auditoria'
      path: '/admin/auditoria'
      fullPath: '/admin/auditoria'
      preLoaderRoute: typeof AppAdminAuditoriaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/configuracion': {
      id: '/_app/admin/configuracion'
      path: '/admin/configuracion'
      fullPath: '/admin/configuracion'
      preLoaderRoute: typeof AppAdminConfiguracionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/equipos': {
      id: '/_app/admin/equipos'
      path: '/admin/equipos'
      fullPath: '/admin/equipos'
      preLoaderRoute: typeof AppAdminEquiposRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/usuarios': {
      id: '/_app/admin/usuarios'
      path: '/admin/usuarios'
      fullPath: '/admin/usuarios'
      preLoaderRoute: typeof AppAdminUsuariosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inspecciones/': {
      id: '/_app/inspecciones/'
      path: '/inspecciones'
      fullPath: '/inspecciones/'
      preLoaderRoute: typeof AppInspeccionesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inspecciones/$inspeccionId': {
      id: '/_app/inspecciones/$inspeccionId'
      path: '/inspecciones/$inspeccionId'
      fullPath: '/inspecciones/$inspeccionId'
      preLoaderRoute: typeof AppInspeccionesInspeccionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plataforma/contactos': {
      id: '/_app/plataforma/contactos'
      path: '/plataforma/contactos'
      fullPath: '/plataforma/contactos'
      preLoaderRoute: typeof AppPlataformaContactosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plataforma/correos': {
      id: '/_app/plataforma/correos'
      path: '/plataforma/correos'
      fullPath: '/plataforma/correos'
      preLoaderRoute: typeof AppPlataformaCorreosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plataforma/cupones': {
      id: '/_app/plataforma/cupones'
      path: '/plataforma/cupones'
      fullPath: '/plataforma/cupones'
      preLoaderRoute: typeof AppPlataformaCuponesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plataforma/metricas': {
      id: '/_app/plataforma/metricas'
      path: '/plataforma/metricas'
      fullPath: '/plataforma/metricas'
      preLoaderRoute: typeof AppPlataformaMetricasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plataforma/talleres': {
      id: '/_app/plataforma/talleres'
      path: '/plataforma/talleres'
      fullPath: '/plataforma/talleres'
      preLoaderRoute: typeof AppPlataformaTalleresRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vehiculos/$patente': {
      id: '/_app/vehiculos/$patente'
      path: '/vehiculos/$patente'
      fullPath: '/vehiculos/$patente'
      preLoaderRoute: typeof AppVehiculosPatenteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plataforma/talleres_/$tallerId/comercial': {
      id: '/_app/plataforma/talleres_/$tallerId/comercial'
      path: '/plataforma/talleres/$tallerId/comercial'
      fullPath: '/plataforma/talleres/$tallerId/comercial'
      preLoaderRoute: typeof AppPlataformaTalleresTallerIdComercialRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plataforma/talleres_/$tallerId/fotos': {
      id: '/_app/plataforma/talleres_/$tallerId/fotos'
      path: '/plataforma/talleres/$tallerId/fotos'
      fullPath: '/plataforma/talleres/$tallerId/fotos'
      preLoaderRoute: typeof AppPlataformaTalleresTallerIdFotosRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppActividadRoute: typeof AppActividadRoute
  AppRepuestosRoute: typeof AppRepuestosRoute
  AppTableroRoute: typeof AppTableroRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAdminAuditoriaRoute: typeof AppAdminAuditoriaRoute
  AppAdminConfiguracionRoute: typeof AppAdminConfiguracionRoute
  AppAdminEquiposRoute: typeof AppAdminEquiposRoute
  AppAdminUsuariosRoute: typeof AppAdminUsuariosRoute
  AppInspeccionesInspeccionIdRoute: typeof AppInspeccionesInspeccionIdRoute
  AppPlataformaContactosRoute: typeof AppPlataformaContactosRoute
  AppPlataformaCorreosRoute: typeof AppPlataformaCorreosRoute
  AppPlataformaCuponesRoute: typeof AppPlataformaCuponesRoute
  AppPlataformaMetricasRoute: typeof AppPlataformaMetricasRoute
  AppPlataformaTalleresRoute: typeof AppPlataformaTalleresRoute
  AppVehiculosPatenteRoute: typeof AppVehiculosPatenteRoute
  AppInspeccionesIndexRoute: typeof AppInspeccionesIndexRoute
  AppPlataformaTalleresTallerIdComercialRoute: typeof AppPlataformaTalleresTallerIdComercialRoute
  AppPlataformaTalleresTallerIdFotosRoute: typeof AppPlataformaTalleresTallerIdFotosRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActividadRoute: AppActividadRoute,
  AppRepuestosRoute: AppRepuestosRoute,
  AppTableroRoute: AppTableroRoute,
  AppIndexRoute: AppIndexRoute,
  AppAdminAuditoriaRoute: AppAdminAuditoriaRoute,
  AppAdminConfiguracionRoute: AppAdminConfiguracionRoute,
  AppAdminEquiposRoute: AppAdminEquiposRoute,
  AppAdminUsuariosRoute: AppAdminUsuariosRoute,
  AppInspeccionesInspeccionIdRoute: AppInspeccionesInspeccionIdRoute,
  AppPlataformaContactosRoute: AppPlataformaContactosRoute,
  AppPlataformaCorreosRoute: AppPlataformaCorreosRoute,
  AppPlataformaCuponesRoute: AppPlataformaCuponesRoute,
  AppPlataformaMetricasRoute: AppPlataformaMetricasRoute,
  AppPlataformaTalleresRoute: AppPlataformaTalleresRoute,
  AppVehiculosPatenteRoute: AppVehiculosPatenteRoute,
  AppInspeccionesIndexRoute: AppInspeccionesIndexRoute,
  AppPlataformaTalleresTallerIdComercialRoute:
    AppPlataformaTalleresTallerIdComercialRoute,
  AppPlataformaTalleresTallerIdFotosRoute:
    AppPlataformaTalleresTallerIdFotosRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AccionRoute: AccionRoute,
  CambiarClaveRoute: CambiarClaveRoute,
  IngresarRoute: IngresarRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
